// File: frontend/src/components/Settings/NotificationSettings.jsx
// Notification settings component

import SystemSettings from './SystemSettings';

const NotificationSettings = () => {
  return (
    <SystemSettings filter="notifications" />
  );
};

export default NotificationSettings;